import React, { useContext } from 'react';
import { WindowSizeContext } from '/src/App';
import './style.css';

const RiskModal = ({ risk, onClose }) => {

  const { deviceType } = useContext(WindowSizeContext);

  const getImpactSystemsText = (level) => {
    switch (level.toLowerCase()) {
      case 'high':
        return 'Affects Many Home Systems';
      case 'medium':
        return 'Affects Several Home Systems';
      case 'low':
        return 'Affects Few Home Systems';
      default:
        return '';
    }
  };

  const getFixesRequiredText = (level) => {
    switch (level.toLowerCase()) {
      case 'high':
        return 'Often Requires Major Fixes';
      case 'medium':
        return 'May Require Moderate Fixes';
      case 'low':
        return 'Usually Requires Minor Fixes';
      default:
        return '';
    }
  };


  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="risk-modal" onClick={e => e.stopPropagation()}>
        <div
          className="modal-header"
          style={{
            backgroundImage: `url(${import.meta.env.VITE_CONTENT_CDN_BASE_URL}/${risk.image})`
          }}
        >
          <h2>{risk.risk_name}</h2>
          <div className={`risk-level ${risk.risk_level.toLowerCase()}`}>
            {risk.risk_level} Risk of Financial Impact
          </div>
        </div>

        <div className="modal-content">
          <p className="risk-description">{risk.blurb}</p>

          <div className={`risk-stats ${risk.stats?.length === 3 ? 'risk-stats-3-columns' : 'risk-stats-2-columns'}`}>
            {risk.stats?.map((stat, index) => (
              <div key={index} className="stat-item">
                <span className={`stat-value text-align-center ${deviceType}`}>{stat.stat}</span>
                <span className={`stat-label text-align-center ${deviceType}`}>{stat.headline}</span>
              </div>
            ))}
          </div>

          <div className={`impact-factors ${deviceType}`}>
            <span>{getImpactSystemsText(risk.impact_factors_home_systems_affected)}</span>
            <span>{getFixesRequiredText(risk.impact_factors_fixes_necessitated)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskModal; 